import { useMutation as useApolloMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

import type { Response, MutationVars } from './mutation'
import createIdentityDataRequestMutation from './mutation'

export const useCreateIdentityDataRequestMutation: WrappedMutation<
  Response,
  MutationVars
> = () =>
  useApolloMutation<Response, MutationVars>(createIdentityDataRequestMutation, {
    client: agentClient,
    fetchPolicy: 'network-only',
  })
